import Api from "@/api"
import { IncidentStatus, type CardinalDirection, type IncidentLog, type SeaState, type User } from "@/models"
import { Now, Temporal } from "@/Temporal"
import { mergePromises } from "vue-utils"

export async function createBlankTemplateIncidentLog(loggedInUser: User): Promise<IncidentLog> {
	const { weather, tide } = await mergePromises({
		weather: Api.weather.getCurrentConditions(),
		tide: Api.weather.getCurrentTide(),
	})

	return {
		id: 0,
		identifier: "000/00",
		incidentTime: Temporal.Now.instant(),
		createdBy: loggedInUser.createTimeStamp(),

		status: IncidentStatus.Open,

		SMCOnDutyId: null,

		primaryMWOId: null,
		secondaryMWOId: null,

		reportedIncidentTypeId: null!,
		finalIncidentTypeId: null!,

		initialEmergencyPhase: null!,
		finalEmergencyPhase: null!,

		nameOfVesselOrCasualty: "",
		personsAtRisk: 0,

		positions: [
			{
				id: 1,
				position: {
					latitude: NaN,
					longitude: NaN,
				},
				receivedAt: Now.instant(),
			},
		],

		messageReceived: "",
		natureOfIncident: "",
		descriptionOfCasualty: null,

		shipDescription: {
			length: null,
			hullColour: null,
			superstructureColour: null,
			sailColour: null,
			additionalInformation: "",
		},
		assetsTasked: [],
		callReceived: {
			VHFChannel: null,
			VHFChannelOther: false,
			DSC: false,
			MMSI: null,
			callSign: null,
			EPIRB: false,
			emergency999: false,
			phoneNumber: null,
			callerName: null,
		},
		registrationInformation: {
			portOfRegistry: null,
			homePort: null,
			ownerName: null,
			ownerAddress: null,
		},
		weatherConditions: weather ?? {
			seaState: "" as SeaState,
			windDirection: "" as CardinalDirection,
			visibilityNm: NaN,
			windSpeedKnots: NaN,
		},
		currentTide: tide ?? {
			lowWater: {
				height: NaN,
				time: null!,
			},
			highWater: {
				height: NaN,
				time: null!,
			},
		},
		incidentNarrative: [],
		incidentDocuments: [],

		reopened: null,
		closed: null,
		signedOff: null,
	}
}
